import { APP_STORE_URL } from '../../utils/constants';

export default function Footer() {
  return (
    <footer className="border-t border-white/5 bg-surface">
      <div className="container-custom py-10">
        <div className="flex flex-col md:flex-row justify-between items-center gap-6">
          <div className="flex items-center gap-6">
            <span className="text-sm font-semibold bg-gradient-brand bg-clip-text text-transparent">
              Creator Voice
            </span>
            <span className="text-white/30 text-xs">
              &copy; {new Date().getFullYear()} Resonance
            </span>
          </div>

          <div className="flex items-center gap-6 text-xs text-white/40">
            <a href="#" className="hover:text-white/70 transition-colors">Privacy Policy</a>
            <a href="#" className="hover:text-white/70 transition-colors">Terms of Service</a>
            <a
              href={APP_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:text-white/70 transition-colors"
            >
              App Store
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
